import type { FaireProductEntity } from "../../entity_types/product";

export const p_4mk4ytnudr: FaireProductEntity = {
  token: "p_4mk4ytnudr",
  type: "product",
  name: "The Mexican Vegetarian Cookbook",
  brandToken: "b_daarv8jc3a",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/f7c8565ef74d1882c9770212d7bc53afaa57f1dec6f434e6b4f42dcc06e6a965.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/965b489129c326b81706726780acc8a4da423a0bfbf17d32174912ffcf4cd027.webp",
    "https://cdn.faire.com/fastly/a7a911d364bd47b51139bba75b7192dd483c7ab5b3f51f72690d8cdd8b141287.webp",
    "https://cdn.faire.com/fastly/fa895f5edb075abc2155736a825bb4f0977ff13a4d34f9a806c20a3e5a64cd08.webp",
    "https://cdn.faire.com/fastly/dfcc3ace67d61d3b70cb2622cadd43a17534466b747abe6daab587a77157569e.webp",
    "https://cdn.faire.com/fastly/a08747fe60932dd62fa3aa10632abdae2e193253ed0b780fc15dfd2c05757658.webp",
    "https://cdn.faire.com/fastly/4d63fbe47f28d66b2cc9e8fc4240af2bcc63de09d57924af21e72c745142931a.webp",
    "https://cdn.faire.com/fastly/fc45cbe8bb1305f3a482add8108cebf014c83ca08504abe45d6bd33a06fe463a.webp",
    "https://cdn.faire.com/fastly/d9105c7d45838d2a31367a8b8996e8c26c4cf52b7fb7dc268d8f0b1f6657d993.webp",
    "https://cdn.faire.com/fastly/e4958ebfced4659a7e30e4991a7de4d531a3f49cc504c2d9fdac7909b5b48d6e.webp",
  ],
  priceDollars: 27.48,
  description:
    "'Like the Mexican Joy of Cooking.' –  Bon Appétit\n\nAn essential guide to vibrant, vegetarian Mexican home cooking, including naturally vegan, gluten-free, and dairy-free dishes – with more than 400 authentic everyday recipes for the home cook\n\nVegetarian food is deeply woven into Mexico's diverse culinary history. In this blockbuster recipe collection from the bestselling author of Mexico: The Cookbook, home cooks will discover delicious traditional and modern dishes made with corn, beans, spices, and the incredible bounty of fruit, vegetables, legumes, seeds, and edible flowers grown across Mexico.\n\nThese healthy, wholesome recipes are meat-free by design, spotlighting Mexico's outstanding foods, instead of relying on hard-to-source ingredients or substitutions. Each is presented with clear, straightforward instructions accessible to home cooks of all skill levels.",
  tags: [],
  msrpDollars: 54.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:32.672Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
